import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=b4858bec&scoped=true"
import script from "./BoxView.vue?vue&type=script&lang=js"
export * from "./BoxView.vue?vue&type=script&lang=js"
import style0 from "./BoxView.vue?vue&type=style&index=0&id=b4858bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4858bec",
  null
  
)

export default component.exports